import { useQuery } from '@tanstack/react-query';

import { rpcClient } from '../lib/orpc.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business Fetches each season's usable stock and outfit generation ceiling. The underlying inventory is synced daily, so the result is kept fresh for a long window.
 * @graph-connects rpcClient [calls] oRPC coorde.capacity 呼び出し
 */
export function useCoordeCapacity() {
  return useQuery({
    queryKey: queryKeys.coorde.capacity,
    queryFn: () => rpcClient.coorde.capacity(),
    staleTime: 30 * 60_000,
    retry: false,
  });
}
